import React from 'react'
import cssModules from 'react-css-modules'
import styles from './create_prepublish.less'
import { getI18n } from 'client/i18n'
import { Link, withRouter } from 'react-router'

import CreateDisclaimer from 'components/pages/create/create_disclaimer'

const i18n = getI18n('components/pages/create/pool_publish')

class PoolPrepublish extends React.Component {
  render() {
    return (
      <div>
        <div styleName="title">{i18n('title')}</div>

        <CreateDisclaimer />

        <Link
          data-nemo="agree-publish"
          to={{ pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/publish` }}
          className="vx_btn vx_btn-block"
          styleName="submit-button"
        >
          {i18n('publish')}
        </Link>
      </div>
    )
  }
}

export default withRouter(cssModules(PoolPrepublish, styles))
